/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import useDailyTaskHistory from '@api/hooks/activity/useDailyTaskHistory';
import { isStreaksNewFlow } from '@layout/Header/HeaderUser/util';
import StreakItemV2 from './StreakItemV2';

const StreamItemWrapper = styled.div`
  position: relative;
  height: ${({ size }) => `${size}px`};
  padding-left: ${({ position }) => (position === 0 ? 0 : '16px')};
`;

const Bg = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: var(--color-i-blue);
  opacity: 0.1;
  z-index: -1;
`;

const LeftBg = styled(Bg)`
  left: 0;
  width: ${({ $position }) => ($position === 0 ? '16px' : '32px')};
`;

const RightBg = styled(Bg)`
  right: 0;
  width: 16px;
`;

const StreakItem = ({ dailyTask, position, isGroups }) => {
  const isInStreak = dailyTask.is_in_streak;
  const isInOngoingStreak = dailyTask.is_in_ongoing_streak;
  const showStreakBg = isInStreak && isInOngoingStreak;
  const { dailyTaskHistory } = useDailyTaskHistory();

  const streakNewFlow = isStreaksNewFlow(dailyTaskHistory?.experimentBucket);
  const {
    watchmins = 0,
    question,
    questions
  } = dailyTask.percentageCompleted || {};
  const questionsAttempted = question || questions;
  const showQuestionAttemptProgress =
    streakNewFlow && questionsAttempted !== undefined;
  const size = isGroups ? 24 : 32;

  return (
    <StreamItemWrapper
      position={position}
      size={size}
      className="StreamItemWrapper"
    >
      {showStreakBg && !dailyTask.start && (
        <LeftBg $position={position} className="LeftBg" />
      )}
      {showStreakBg && !dailyTask.end && <RightBg className="RightBg" />}
      <StreakItemV2
        dailyWatchMinPercentage={watchmins}
        questionsAttemptPercentage={questionsAttempted}
        isStreaksNewFlow={showQuestionAttemptProgress}
        size={size}
        strokeWidth={3}
        outerSqSize={size}
        innerSqSize={isGroups ? 14 : 22}
        isCompleted={dailyTask.isCompleted}
      />
    </StreamItemWrapper>
  );
};

StreakItem.propTypes = {
  dailyTask: PropTypes.objectOf(PropTypes.any).isRequired,
  position: PropTypes.number.isRequired
};

export default StreakItem;
